import React, { useEffect } from 'react';
import { CheckCircle2, Info } from 'lucide-react';

interface ToastProps {
  message: string | null;
  onClose: () => void;
  type?: 'info' | 'success';
}

export const Toast: React.FC<ToastProps> = ({ message, onClose, type = 'info' }) => {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className="fixed bottom-20 md:bottom-8 left-1/2 -translate-x-1/2 z-50 animate-bounce-in">
      <div className="bg-ink text-white px-5 py-3 rounded-2xl shadow-2xl flex items-center gap-3 text-sm font-medium border border-white/10 backdrop-blur-md">
        {type === 'success' ? (
          <CheckCircle2 className="w-5 h-5 text-jade shrink-0" />
        ) : (
          <Info className="w-5 h-5 text-gold shrink-0" />
        )}
        <span>{message}</span>
      </div>
    </div>
  );
};
